import { groupBy, mapValues } from 'lodash-es'

export const whoIdToLabelMap = mapValues(
    groupBy(
        [
            {
                id: 'secondary_school_student',
                label: 'stredoškoláka',
                hint: '',
                groupInfinitiveLabel: 'študenti strednej školy',
                index: 1
            },
            {
                id: 'university_student',
                label: 'vysokoškoláka',
                hint: '',
                groupInfinitiveLabel: 'študenti vysokej školy',
                index: 2
            },
            {
                id: 'young_professional',
                label: 'mladého profesionála (prac. skúsenosti do 3 rokov od ukončenia VŠ)',
                hint: '',
                groupInfinitiveLabel: 'mladí profesionáli',
                index: 3
            },
            {
                id: 'professional',
                label: 'profesionála',
                hint: '(viac ako 3 roky skúseností)',
                groupInfinitiveLabel: 'profesionáli',
                index: 4
            },
            {
                id: 'teacher',
                label: 'učiteľa, riaditeľa školy',
                hint: '',
                groupInfinitiveLabel: 'učitelia',
                index: 5
            },
            {
                id: 'secondary_school_project',
                label: 'študentský projekt',
                hint: '',
                groupInfinitiveLabel: 'študentské projekty',
                index: 6
            },
            {
                id: 'ngo_school',
                label: 'neziskovú organizáciu',
                hint: '',
                groupInfinitiveLabel: 'neziskové organizácie',
                index: 7
            },
            {
                id: 'public_institution',
                label: 'verejnú inštitúciu',
                hint: '',
                groupInfinitiveLabel: 'verejné inštitúcie',
                index: 8
            },
            {
                id: 'organization_growing_company',
                label: 'startup',
                hint: '',
                groupInfinitiveLabel: 'startupy',
                index: 9
            }
        ],
        'id'
    ),
    (value) => value[0]
)

// TODO: Dropped for now
export const topicsIdToLabelMap = mapValues(
    groupBy(
        [
            {
                id: 'selection_and_application_university',
                label: 'výber a prihláška na VŠ'
            },
            {
                id: 'subjects_beyond_school',
                label: 'predmety nad rámec školy (napr. fyzika, biológia, dejepis, ...)'
            },
            {
                id: 'academic_field',
                label: 'akademické oblasti'
            },
            {
                id: 'learning_and_developing_strengths',
                label: 'spoznávanie a rozvoj silných stránok menteeho (napr. podnikavosť, vedenie ľudí, komunikácia, ...)'
            },
            {
                id: 'how_my_department_works_in_practice',
                label: 'ako funguje môj odbor v praxi (napr. marketing, politika, verejný sektor, startup, rozvoj vlastného biznisu, veda, IT, tvorba videí, ...);'
            },
            {
                id: 'needs_help_as_next',
                label: 'ak je bezradný/á a potrebuje zistiť ako ďalej :)'
            },
            {
                id: 'after_school_activity',
                label: 'rozvíjať sa v mimoškolskej aktivite (napr. debata, umenie, ...);'
            },
            {
                id: 'others',
                label: 'aj akékoľvek iné'
            }
        ],
        'id'
    ),
    (value) => value[0]
)

// TODO: Dropped for now
export const maturityIdToLabelMap = mapValues(
    groupBy(
        [
            {
                id: 'beginner_0_3_years',
                label: 'Začínam (0-3 rokov)'
            },
            {
                id: 'middle_4_10_years',
                label: 'Už mám skúsenosti (4 - 10 rokov)'
            },
            {
                id: 'expert_10plus_years',
                label: 'Som odborník (10+)'
            }
        ],
        'id'
    ),
    (value) => value[0]
)

export const howIdToLabelMap = mapValues(
    groupBy(
        [
            {
                id: 'remotely',
                label: 'na diaľku (online)'
            },
            {
                id: 'in_person',
                label: 'osobné stretnutia'
            }
        ],
        'id'
    ),
    (value) => value[0]
)

export const durationProjectToLabelMap = mapValues(
    groupBy(
        [
            {
                id: 'once',
                label: 'krátkodobá (do 3 mesiacov, max 2-3 konzultácie alebo jednorazová pomoc)',
                index: 1
            },
            {
                id: 'long_term',
                label: 'dlhodobá',
                index: 2
            }
        ],
        'id'
    ),
    (value) => value[0]
)

export const durationToLabelMap = mapValues(
    groupBy(
        [
            {
                id: 'once',
                label: 'jednorazová konzultácia',
                index: 1
            },
            {
                id: 'long_term',
                label: 'dlhodobý mentoring',
                index: 2
            }
        ],
        'id'
    ),
    (value) => value[0]
)

export const experienceToLabelMap = mapValues(
    groupBy(
        [
            {
                id: 'yes',
                label: 'Áno',
                index: 1
            },
            {
                id: 'no',
                label: 'Ešte nie',
                index: 2
            }
        ],
        'id'
    ),
    (value) => value[0]
)

// TODO: Dropped for now
export const academicalAreaToLabelMap = mapValues(
    groupBy(
        [
            {
                subCategory: 'humanitne_a_spolocenske_vedy',
                label: 'Antropológia',
                id: 'antropologia'
            },
            {
                subCategory: 'humanitne_a_spolocenske_vedy',
                label: 'Archeológia',
                id: 'archeologia'
            },
            {
                subCategory: 'humanitne_a_spolocenske_vedy',
                label: 'Dizajn',
                id: 'humanitne_a_spolocenske_vedy_dizajn'
            },
            {
                subCategory: 'humanitne_a_spolocenske_vedy',
                label: 'Estetika',
                id: 'estetika'
            },
            {
                subCategory: 'humanitne_a_spolocenske_vedy',
                label: 'Filozofia',
                id: 'filozofia'
            },
            {
                subCategory: 'humanitne_a_spolocenske_vedy',
                label: 'História',
                id: 'historia'
            },
            {
                subCategory: 'humanitne_a_spolocenske_vedy',
                label: 'Literárna veda',
                id: 'literarna_veda'
            },
            {
                subCategory: 'humanitne_a_spolocenske_vedy',
                label: 'Politológia',
                id: 'politologia'
            },
            {
                subCategory: 'humanitne_a_spolocenske_vedy',
                label: 'Prekladateľstvo a tlmočníctvo',
                id: 'prekladatelstvo_a_tlmocnictvo'
            },
            {
                subCategory: 'humanitne_a_spolocenske_vedy',
                label: 'Psychológia',
                id: 'psychologia'
            },
            {
                subCategory: 'humanitne_a_spolocenske_vedy',
                label: 'Sociológia',
                id: 'sociologia'
            },
            {
                subCategory: 'humanitne_a_spolocenske_vedy',
                label: 'Sociálne služby a poradenstvo',
                id: 'socialne_sluzby_a_poradenstvo'
            },
            {
                subCategory: 'humanitne_a_spolocenske_vedy',
                label: 'Iné',
                id: 'humanitne_a_spolocenske_vedy_ine'
            },
            {
                subCategory: 'ekonomicke_a_pravne_vedy',
                label: 'Ekonomika',
                id: 'ekonomika'
            },
            {
                subCategory: 'ekonomicke_a_pravne_vedy',
                label: 'Financie',
                id: 'financie'
            },
            {
                subCategory: 'ekonomicke_a_pravne_vedy',
                label: 'Obchodné podnikanie',
                id: 'obchodne_podnikanie'
            },
            {
                subCategory: 'ekonomicke_a_pravne_vedy',
                label: 'Účtovníctvo',
                id: 'uctovnictvo'
            },
            {
                subCategory: 'ekonomicke_a_pravne_vedy',
                label: 'Obchod a marketing',
                id: 'obchod_a_marketing'
            },
            {
                subCategory: 'ekonomicke_a_pravne_vedy',
                label: 'Manažment',
                id: 'manazment'
            },
            {
                subCategory: 'ekonomicke_a_pravne_vedy',
                label: 'Ľudské zdroje a personálny manažment',
                id: 'ludske_zdroje_a_personalny_manazment'
            },
            {
                subCategory: 'ekonomicke_a_pravne_vedy',
                label: 'Medzinárodné ekonomické vzťahy',
                id: 'medzinarodne_ekonomicke_vztahy'
            },
            {
                subCategory: 'ekonomicke_a_pravne_vedy',
                label: 'Právo',
                id: 'pravo'
            },
            {
                subCategory: 'ekonomicke_a_pravne_vedy',
                label: 'Iné',
                id: 'ekonomicke_a_pravne_vedy_ine'
            },
            {
                subCategory: 'informaticke_vedy_matematika',
                label: 'Informatika',
                id: 'informatika'
            },
            {
                subCategory: 'informaticke_vedy_matematika',
                label: 'Počítačové inžinierstvo',
                id: 'pocitacove_inzinierstvo'
            },
            {
                subCategory: 'informaticke_vedy_matematika',
                label: 'Softvérové inžinierstvo',
                id: 'softverove_inzinierstvo'
            },
            {
                subCategory: 'informaticke_vedy_matematika',
                label: 'Informačné systémy',
                id: 'informacne_systemy'
            },
            {
                subCategory: 'informaticke_vedy_matematika',
                label: 'Kybernetika',
                id: 'kybernetika'
            },
            {
                subCategory: 'informaticke_vedy_matematika',
                label: 'Umelá inteligencia',
                id: 'umela_inteligencia'
            },
            {
                subCategory: 'informaticke_vedy_matematika',
                label: 'Kognitívna veda',
                id: 'kognitivna_veda'
            },
            {
                subCategory: 'informaticke_vedy_matematika',
                label: 'Matematika',
                id: 'matematika'
            },
            {
                subCategory: 'informaticke_vedy_matematika',
                label: 'Štatistika',
                id: 'statistika'
            },
            {
                subCategory: 'informaticke_vedy_matematika',
                label: 'Iné',
                id: 'informaticke_vedy_matematika_ine'
            },
            {
                subCategory: 'architektura_a_stavitelstvo',
                label: 'Architektúra',
                id: 'architektura'
            },
            {
                subCategory: 'architektura_a_stavitelstvo',
                label: 'Priestorové plánovanie',
                id: 'priestorove_planovanie'
            },
            {
                subCategory: 'architektura_a_stavitelstvo',
                label: 'Stavebníctvo',
                id: 'stavebnictvo'
            },
            {
                subCategory: 'architektura_a_stavitelstvo',
                label: 'Iné',
                id: 'architektura_a_stavitelstvo_ine'
            },
            { subCategory: 'prirodne_vedy', label: 'Fyzika', id: 'fyzika' },
            {
                subCategory: 'prirodne_vedy',
                label: 'Astronómia',
                id: 'astronomia'
            },
            {
                subCategory: 'prirodne_vedy',
                label: 'Astrofyzika',
                id: 'astrofyzika'
            },
            { subCategory: 'prirodne_vedy', label: 'Chémia', id: 'chemia' },
            {
                subCategory: 'prirodne_vedy',
                label: 'Biochémia',
                id: 'biochemia'
            },
            { subCategory: 'prirodne_vedy', label: 'Biológia', id: 'biologia' },
            { subCategory: 'prirodne_vedy', label: 'Geológia', id: 'geologia' },
            {
                subCategory: 'prirodne_vedy',
                label: 'Iné',
                id: 'prirodne_vedy_ine'
            },
            {
                subCategory: 'umenie',
                label: 'Výtvarné umenie',
                id: 'vytvarne_umenie'
            },
            { subCategory: 'umenie', label: 'Hudobné', id: 'hudobne' },
            {
                subCategory: 'umenie',
                label: 'Tanečné umenie',
                id: 'tanecne_umenie'
            },
            {
                subCategory: 'umenie',
                label: 'Divadelné umenie',
                id: 'divadelne_umenie'
            },
            {
                subCategory: 'umenie',
                label: 'Filmová tvorba',
                id: 'filmova_tvorba'
            },
            { subCategory: 'umenie', label: 'Dizajn', id: 'dizajn' },
            { subCategory: 'umenie', label: 'Iné', id: 'umenie_ine' },
            {
                subCategory: 'vzdelavanie',
                label: 'Pedagogika',
                id: 'pedagogika'
            },
            {
                subCategory: 'vzdelavanie',
                label: 'Andragogika',
                id: 'andragogika'
            },
            { subCategory: 'vzdelavanie', label: 'Iné', id: 'vzdelavanie_ine' },
            {
                subCategory: 'zdravotnictvo_a_farmaceuticke_vedy',
                label: 'Farmácia',
                id: 'farmacia'
            },
            {
                subCategory: 'zdravotnictvo_a_farmaceuticke_vedy',
                label: 'Farmakológia',
                id: 'farmakologia'
            },
            {
                subCategory: 'zdravotnictvo_a_farmaceuticke_vedy',
                label: 'Medicína',
                id: 'medicina'
            },
            {
                subCategory: 'zdravotnictvo_a_farmaceuticke_vedy',
                label: 'Ošetrovateľstvo',
                id: 'osetrovatelstvo'
            },
            {
                subCategory: 'zdravotnictvo_a_farmaceuticke_vedy',
                label: 'Verejne zdravotníctvo',
                id: 'verejne_zdravotnictvo'
            },
            {
                subCategory: 'zdravotnictvo_a_farmaceuticke_vedy',
                label: 'Zubné lekárstvo',
                id: 'zubne_lekarstvo'
            },
            {
                subCategory: 'zdravotnictvo_a_farmaceuticke_vedy',
                label: 'Iné',
                id: 'zdravotnictvo_a_farmaceuticke_vedy_ine'
            }
        ],
        'id'
    ),
    (value) => value[0]
)

// TODO: Dropped for now
export const expertiseIdToLabelMap = mapValues(
    groupBy(
        [
            { id: 'accounting', label: 'Accounting' },
            { id: 'airlines_aviation', label: 'Airlines/Aviation' },
            {
                id: 'alternative_dispute_resolution',
                label: 'Alternative Dispute Resolution'
            },
            { id: 'alternative_medicine', label: 'Alternative Medicine' },
            { id: 'animation', label: 'Animation' },
            { id: 'apparel_fashion', label: 'Apparel & Fashion' },
            { id: 'architecture__planning', label: 'Architecture & Planning' },
            { id: 'arts_and_crafts', label: 'Arts and Crafts' },
            { id: 'automotive', label: 'Automotive' },
            { id: 'aviation_&_aerospace', label: 'Aviation & Aerospace' },
            { id: 'banking', label: 'Banking' },
            { id: 'biotechnology', label: 'Biotechnology' },
            { id: 'broadcast_media', label: 'Broadcast Media' },
            { id: 'building_materials', label: 'Building Materials' },
            {
                id: 'business_supplies_and_equipment',
                label: 'Business Supplies and Equipment'
            },
            { id: 'capital_markets', label: 'Capital Markets' },
            { id: 'chemicals', label: 'Chemicals' },
            {
                id: 'civic_&_social_organization',
                label: 'Civic & Social Organization'
            },
            { id: 'civil_engineering', label: 'Civil Engineering' },
            { id: 'commercial_real_estate', label: 'Commercial Real Estate' },
            {
                id: 'computer_&_network_security',
                label: 'Computer & Network Security'
            },
            { id: 'computer_games', label: 'Computer Games' },
            { id: 'computer_hardware', label: 'Computer Hardware' },
            { id: 'computer_networking', label: 'Computer Networking' },
            { id: 'computer_software', label: 'Computer Software' },
            { id: 'construction', label: 'Construction' },
            { id: 'consumer_electronics', label: 'Consumer Electronics' },
            { id: 'consumer_goods', label: 'Consumer Goods' },
            { id: 'consumer_services', label: 'Consumer Services' },
            { id: 'cosmetics', label: 'Cosmetics' },
            { id: 'dairy', label: 'Dairy' },
            { id: 'defense_&_space', label: 'Defense & Space' },
            { id: 'design', label: 'Design' },
            { id: 'education_management', label: 'Education Management' },
            { id: 'e_learning', label: 'E-Learning' },
            {
                id: 'electricalelectronic_manufacturing',
                label: 'Electrical/Electronic Manufacturing'
            },
            { id: 'entertainment', label: 'Entertainment' },
            { id: 'environmental_services', label: 'Environmental Services' },
            { id: 'events_services', label: 'Events Services' },
            { id: 'executive_office', label: 'Executive Office' },
            { id: 'facilities_services', label: 'Facilities Services' },
            { id: 'farming', label: 'Farming' },
            { id: 'financial_services', label: 'Financial Services' },
            { id: 'fine_art', label: 'Fine Art' },
            { id: 'fishery', label: 'Fishery' },
            { id: 'food_&_beverages', label: 'Food & Beverages' },
            { id: 'food_production', label: 'Food Production' },
            { id: 'fund_raising', label: 'Fund-Raising' },
            { id: 'furniture', label: 'Furniture' },
            { id: 'gambling_casinos', label: 'Gambling & Casinos' },
            {
                id: 'glass_ceramics_concrete',
                label: 'Glass, Ceramics & Concrete'
            },
            {
                id: 'government_administration',
                label: 'Government Administration'
            },
            { id: 'government_relations', label: 'Government Relations' },
            { id: 'graphic_design', label: 'Graphic Design' },
            {
                id: 'health_wellness_and_fitness',
                label: 'Health, Wellness and Fitness'
            },
            { id: 'higher_education', label: 'Higher Education' },
            { id: 'hospital_&_health_care', label: 'Hospital & Health Care' },
            { id: 'hospitality', label: 'Hospitality' },
            { id: 'human_resources', label: 'Human Resources' },
            { id: 'import_and_export', label: 'Import and Export' },
            {
                id: 'individual_family_services',
                label: 'Individual & Family Services'
            },
            { id: 'industrial_automation', label: 'Industrial Automation' },
            { id: 'information_services', label: 'Information Services' },
            {
                id: 'information_technology_and_services',
                label: 'Information Technology and Services'
            },
            { id: 'insurance', label: 'Insurance' },
            { id: 'international_affairs', label: 'International Affairs' },
            {
                id: 'international_trade_and_development',
                label: 'International Trade and Development'
            },
            { id: 'internet', label: 'Internet' },
            { id: 'investment_banking', label: 'Investment Banking' },
            { id: 'investment_management', label: 'Investment Management' },
            { id: 'judiciary', label: 'Judiciary' },
            { id: 'law_enforcement', label: 'Law Enforcement' },
            { id: 'law_practice', label: 'Law Practice' },
            { id: 'legal_services', label: 'Legal Services' },
            { id: 'legislative_office', label: 'Legislative Office' },
            {
                id: 'leisure_travel_&_tourism',
                label: 'Leisure, Travel & Tourism'
            },
            { id: 'libraries', label: 'Libraries' },
            {
                id: 'logistics_and_supply_chain',
                label: 'Logistics and Supply Chain'
            },
            { id: 'luxury_goods_&_jewelry', label: 'Luxury Goods & Jewelry' },
            { id: 'machinery', label: 'Machinery' },
            { id: 'management_consulting', label: 'Management Consulting' },
            { id: 'maritime', label: 'Maritime' },
            { id: 'market_research', label: 'Market Research' },
            {
                id: 'marketing_and_advertising',
                label: 'Marketing and Advertising'
            },
            {
                id: 'mechanical_or_industrial_engineering',
                label: 'Mechanical or Industrial Engineering'
            },
            { id: 'media_production', label: 'Media Production' },
            { id: 'medical_devices', label: 'Medical Devices' },
            { id: 'medical_practice', label: 'Medical Practice' },
            { id: 'mental_health_care', label: 'Mental Health Care' },
            { id: 'military', label: 'Military' },
            { id: 'mining__metals', label: 'Mining & Metals' },
            {
                id: 'motion_pictures_and_film',
                label: 'Motion Pictures and Film'
            },
            {
                id: 'museums_and_institutions',
                label: 'Museums and Institutions'
            },
            { id: 'music', label: 'Music' },
            { id: 'nanotechnology', label: 'Nanotechnology' },
            { id: 'newspapers', label: 'Newspapers' },
            {
                id: 'non_profit_organization_management',
                label: 'Non-Profit Organization Management'
            },
            { id: 'oil_&_energy', label: 'Oil & Energy' },
            { id: 'online_media', label: 'Online Media' },
            { id: 'outsourcingoffshoring', label: 'Outsourcing/Offshoring' },
            {
                id: 'packagefreight_delivery',
                label: 'Package/Freight Delivery'
            },
            {
                id: 'packaging_and_containers',
                label: 'Packaging and Containers'
            },
            { id: 'paper_&_forest_products', label: 'Paper & Forest Products' },
            { id: 'performing_arts', label: 'Performing Arts' },
            { id: 'pharmaceuticals', label: 'Pharmaceuticals' },
            { id: 'philanthropy', label: 'Philanthropy' },
            { id: 'photography', label: 'Photography' },
            { id: 'plastics', label: 'Plastics' },
            { id: 'political_organization', label: 'Political Organization' },
            {
                id: 'primary_secondary_education',
                label: 'Primary/Secondary Education'
            },
            { id: 'printing', label: 'Printing' },
            {
                id: 'professional_training_&_coaching',
                label: 'Professional Training & Coaching'
            },
            { id: 'program_development', label: 'Program Development' },
            { id: 'public_policy', label: 'Public Policy' },
            {
                id: 'public_relations_and_communications',
                label: 'Public Relations and Communications'
            },
            { id: 'public_safety', label: 'Public Safety' },
            { id: 'publishing', label: 'Publishing' },
            { id: 'railroad_manufacture', label: 'Railroad Manufacture' },
            { id: 'ranching', label: 'Ranching' },
            { id: 'real_estate', label: 'Real Estate' },
            {
                id: 'recreational_facilities_and_services',
                label: 'Recreational Facilities and Services'
            },
            { id: 'religious_institutions', label: 'Religious Institutions' },
            {
                id: 'renewables_&_environment',
                label: 'Renewables & Environment'
            },
            { id: 'research', label: 'Research' },
            { id: 'restaurants', label: 'Restaurants' },
            { id: 'retail', label: 'Retail' },
            {
                id: 'security_and_investigations',
                label: 'Security and Investigations'
            },
            { id: 'semiconductors', label: 'Semiconductors' },
            { id: 'shipbuilding', label: 'Shipbuilding' },
            { id: 'sporting_goods', label: 'Sporting Goods' },
            { id: 'sports', label: 'Sports' },
            { id: 'staffing_and_recruiting', label: 'Staffing and Recruiting' },
            { id: 'supermarkets', label: 'Supermarkets' },
            { id: 'telecommunications', label: 'Telecommunications' },
            { id: 'textiles', label: 'Textiles' },
            { id: 'think_tanks', label: 'Think Tanks' },
            { id: 'tobacco', label: 'Tobacco' },
            {
                id: 'translation_and_localization',
                label: 'Translation and Localization'
            },
            {
                id: 'transportation/trucking/railroad',
                label: 'Transportation/Trucking/Railroad'
            },
            { id: 'utilities', label: 'Utilities' },
            {
                id: 'venture_capital_&_private_equity',
                label: 'Venture Capital & Private Equity'
            },
            { id: 'veterinary', label: 'Veterinary' },
            { id: 'warehousing', label: 'Warehousing' },
            { id: 'wholesale', label: 'Wholesale' },
            { id: 'wine_and_spirits', label: 'Wine and Spirits' },
            { id: 'wireless', label: 'Wireless' },
            { id: 'writing_and_editing', label: 'Writing and Editing' }
        ],
        'id'
    ),
    (value) => value[0]
)
